// extracted by mini-css-extract-plugin
export default {"height_h":"rca","half_width_elem":"sca","row":"tca"};
    if(module.hot) {
      // 1738836199133
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  